module.exports = "/_next/static/images/ux-design-awards-gold-2021-ff27361e92dfa3079b38cc0888d56266.png";